import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';

import { getPopupRegistration, openPopup, closePopup, Priority } from 'app/PopupHolder';
import Map from 'app/components/Map';

import Modal from 'components/base/Modal';

import css from './style.scss';

const selectSelection = (state) => {
  return state.getIn(['property', 'selection']) || fromJS({ items: {} });
};


class PropertyGroupMap extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { activePin: null };
  }

  render() {
    const { properties, groupName, selection } = this.props;

    const selectedItems = selection.get('items');

    const isAnythingSelected = selectedItems.valueSeq().some(v => v === true);

    let finalProperties = properties;
    let selectedCount = 0;

    if (isAnythingSelected) {
      finalProperties = properties.filter(p => {
        const propertyIdString = String(p.id);
        const mapValue = selectedItems.get(propertyIdString);

        const isSelected = mapValue === true;

        console.log(`[DEBUG Filter] ID: ${propertyIdString} (Type: ${typeof p.id}), Value: ${mapValue}, Is Selected: ${isSelected}`);

        return isSelected;
      });
      selectedCount = finalProperties.length;
    } else {
      selectedCount = properties.length;
      finalProperties = properties;
    }
    console.log("Total properties count:", properties.length);

    console.log("PropertyGroupMap finalProperties after filter (IDs):", finalProperties.map(p => p.propertyId));

    const pins = fromJS(
      finalProperties.map(({ propertyId, latitude, longitude, listingType, resultIndex }) => ({
        id: propertyId,
        latitude,
        longitude,
        listingType,
        resultIndex: String(resultIndex)
      }))
    );

    const allSelected = isAnythingSelected && selectedCount === properties.length;
    
    const subtitle = isAnythingSelected && !allSelected
      ? `Showing ${selectedCount} Selected Properties`
      : `Showing all ${properties.length} Properties`;

    const mapCaption = `${groupName} Map`;

    return (
      <Modal
        isOpen
        isCloseButton
        uniqId="modal-properties-map"
        padding="16px"
        forceCaptionClass
        width="1300px"
        caption={<span className={css.mapCaption} title={mapCaption}>{mapCaption}</span>}
        subcaption={subtitle}
        closeBtnStyle={{ top: '30px', right: '22px',}}
      >
        <div className={css.modalBody}>
          <Map properties={pins} infoEnabled onModelRender={true} mapstyle={css.map} />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  selection: selectSelection(state)
});

const PropertyGroupMapPopup = connect(mapStateToProps)(PropertyGroupMap);

const registrationId = getPopupRegistration(PropertyGroupMapPopup);

PropertyGroupMapPopup.open = props => openPopup(registrationId, { priority: Priority.LOW, ...props });
PropertyGroupMapPopup.close = () => closePopup({ popup: registrationId });

export default PropertyGroupMapPopup;